import { ListItemIcon, MenuItem, Select, useMediaQuery } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  ParagraphIcon,
} from "../../../assets/Icons";

const headingAction = (editor, val) =>
  editor.chain().focus().toggleHeading({ level: val }).run();

const options = [
  {
    action: (editor) => editor.chain().focus().setParagraph().run(),
    label: "paragraph",
    icon: <ParagraphIcon />,
    val: "para",
  },
  {
    action: (editor) => headingAction(editor, 2),
    label: "h2-tag",
    icon: <Heading2Icon />,
    val: "2",
  },
  {
    action: (editor) => headingAction(editor, 3),
    label: "h3-tag",
    icon: <Heading3Icon />,
    val: "3",
  },
  {
    action: (editor) => headingAction(editor, 4),
    label: "h4-tag",
    icon: <Heading4Icon />,
    val: "4",
  },
  {
    action: (editor) => headingAction(editor, 5),
    label: "h5-tag",
    icon: <Heading5Icon />,
    val: "5",
  },
  {
    action: (editor) => headingAction(editor, 6),
    label: "h6-tag",
    icon: <Heading6Icon />,
    val: "6",
  },
];

const TypographySelect = ({ editor }) => {
  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const handleChange = (e) => {
    const heading = options.find((el) => el.val === e.target.value);
    heading.action(editor);
  };

  const val = useMemo(() => {
    if (editor.isActive("paragraph")) {
      return "para";
    } else {
      const heading = options.find((el) =>
        editor.isActive("heading", { level: +el.val })
      );
      if (heading) {
        return heading.val;
      }
    }
  }, [handleChange]);

  return (
    <Select
      value={val ?? ""}
      onChange={handleChange}
      style={{
        marginLeft: "10px",
        height: "30px",
      }}
    >
      {options.map((el) => (
        <MenuItem key={t(el.label)} value={el.val}>
          {el.icon && <ListItemIcon>{el.icon}</ListItemIcon>}
          {/* {t(el.label)} */}
          {isSmallScreen
            ? el.val === "para"
              ? "P-tag"
              : el.label.replace("-tag", "")
            : t(el.label)}
        </MenuItem>
      ))}
    </Select>
  );
};

export const OutlineEditorTagSelect = ({ editor }) => {
  const { t } = useTranslation();

  const options = [
    {
      label: "Balise H2",
      icon: <Heading2Icon />,
      value: 2,
    },
    {
      label: "Balise H3",
      icon: <Heading3Icon />,
      value: 3,
    },
    {
      label: "Balise H4",
      icon: <Heading4Icon />,
      value: 4,
    },
    {
      label: "Balise H5",
      icon: <Heading5Icon />,
      value: 5,
    },
    {
      label: "Balise H6",
      icon: <Heading6Icon />,
      value: 6,
    },
  ];

  const handleChange = (event) => {
    const selectedOption = options.find(
      (opt) => opt.value === event.target.value
    );
    if (selectedOption) {
      editor
        .chain()
        .focus()
        .toggleHeading({ level: selectedOption.value })
        .run();
    }
  };

  const value = useMemo(() => {
    const heading = options.find((el) => {
      {
        if (editor.isActive("heading", { level: el.value })) return el;
      }
    });
    if (heading) {
      return heading?.value;
    }
    return 2;
  }, [handleChange]);

  return (
    <Select size="small" value={value} onChange={handleChange}>
      {options.map((el) => (
        <MenuItem key={t(el.label)} value={el.value}>
          <ListItemIcon>{el.icon}</ListItemIcon>
          {el.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default TypographySelect;
